export default "__VITE_ASSET__f0a8b901__"